import type { ReactNode } from 'react';
import { cn } from '../lib/cn';
import { modKey } from '../lib/shortcuts';

export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-sm border border-border-strong',
        'bg-bg-3 px-1 font-sans text-2xs font-medium text-text-2',
        className,
      )}
    >
      {children}
    </kbd>
  );
}

/** Renders a shortcut like `['mod', 'K']` as keycaps (`mod` → ⌘ or Ctrl). */
export function Shortcut({ keys, className }: { keys: readonly string[]; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-0.5', className)}>
      {keys.map((key) => (
        <Kbd key={key}>{key === 'mod' ? modKey() : key}</Kbd>
      ))}
    </span>
  );
}
